import { ApiFailure } from "./client";

// Traducción de los errores de la API al idioma del portal.
//
// El contrato manda `code` y `message` en inglés a propósito (CLAUDE.md §2.7):
// son para máquinas y para quien integra, y cambiarlos rompería a los clientes.
// Pero el portal lo lee una persona en español, y enseñarle
// «invalid email or password» sobre una interfaz en español es enseñarle la
// costura.
//
// La traducción va **por código**, no por texto: el `message` puede cambiar de
// redacción sin aviso, el código no.
const POR_CODIGO: Record<string, string> = {
  UNAUTHORIZED: "Correo o contraseña incorrectos.",
  FORBIDDEN: "Tu cuenta no tiene permiso para esta operación.",
  NOT_FOUND: "No se encontró lo que buscabas.",
  RATE_LIMITED: "Demasiados intentos. Espera un momento antes de volver a probar.",
  MFA_REQUIRED: "Falta el código de tu segundo factor.",
  MFA_ENROLLMENT_REQUIRED:
    "Tu rol exige un segundo factor. Configúralo en Seguridad para continuar.",
  TENANT_SUSPENDED: "La cuenta está suspendida. Contacta a OMITECH.",
  INSUFFICIENT_BALANCE: "Saldo insuficiente para esta operación.",
  IDEMPOTENCY_KEY_REUSED: "Esa operación ya se había enviado con otros datos.",
  INTERNAL_ERROR: "Error interno. Vuelve a intentarlo; si sigue, avisa a OMITECH.",
};

/**
 * mensajeDeError devuelve algo legible en español.
 *
 * Si el código no está en el catálogo cae al `message` de la API, que es
 * inglés pero concreto, y eso es mejor que un «ocurrió un error» que no dice
 * nada. Lo que nunca hace es inventar una causa.
 */
export function mensajeDeError(err: unknown, respaldo: string): string {
  if (!(err instanceof ApiFailure)) return respaldo;
  return POR_CODIGO[err.error.code] ?? err.error.message ?? respaldo;
}
